import { useTranslate } from '@tolgee/react';
import { LINKEDIN_BUSINESS_PAGE } from '../../../../config/constants';
import { AdditionalOptionsFirstComment } from './includes/FirstComment';
import { AdditionalOptionsDisableComments } from './includes/DisableComments';
import { CreatorVerticalSeparator } from '../include/VerticalSeperator';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import {
  applyLinkedinDocumentTitleDefault,
  LINKEDIN_DOCUMENT_TITLE_DEFAULT_KEY,
  linkedinPlatformsNeedingDocumentTitleDefault,
  postHasDocumentMedia,
  setLinkedinDocumentTitle
} from './linkedinDocumentTitle';

export const LinkedinAdditionalOptions: React.FC<any> = ({
  platform = LINKEDIN_BUSINESS_PAGE
}) => {
  const { t } = useTranslate();
  // Both LinkedIn platforms, not just this tab's: the default has to be decided
  // per platform, and each platform's own title is what decides it.
  const postData = useSelector((state: any) => state.lomavisCreator.postData);
  const { linkedin_document_title, media } = postData[platform];
  const dispatch = useDispatch();
  const postHasDocument = postHasDocumentMedia(media);

  // Watching the media list rather than the upload call sites is what makes the
  // default reach every way a PDF can enter a post — the file picker, a drop,
  // the media library popup, the browser extension — since all of them end up
  // in this array.
  useEffect(() => {
    if (linkedinPlatformsNeedingDocumentTitleDefault(postData).length === 0) {
      return;
    }
    // `noWrap`, because this string is stored, not just shown. With
    // REACT_APP_TOLGEE_API_KEY set, `t()` decorates its result with the
    // in-context editor's invisible key markers — and
    // `transferDataToApiFormat` spreads the whole post object into the API
    // payload, so those markers would travel to LinkedIn as part of the title.
    applyLinkedinDocumentTitleDefault(
      dispatch,
      postData,
      t({ key: LINKEDIN_DOCUMENT_TITLE_DEFAULT_KEY, noWrap: true })
    );
  }, [dispatch, t, postData]);

  return (
    <div className="border border-secondary px-2 py-2 rounded">
      <AdditionalOptionsFirstComment
        platform={platform}
      ></AdditionalOptionsFirstComment>
      <CreatorVerticalSeparator />
      <AdditionalOptionsDisableComments platform={platform} />
      <CreatorVerticalSeparator />
      {postHasDocument && (
        <>
          <label htmlFor="linkedin-document-title">
            {t('lomavisCreator.additionalOptions.linkedin_document_title')}
          </label>
          <input
            id="linkedin-document-title"
            type="text"
            value={linkedin_document_title ?? ''}
            className="form-control form-control-sm"
            maxLength={200}
            onChange={(e) => {
              setLinkedinDocumentTitle(dispatch, e.target.value);
            }}
          />
          <span className="text-muted">
            {t(
              'lomavisCreator.additionalOptions.linkedin_document_title_helper'
            )}
          </span>
          <CreatorVerticalSeparator />
        </>
      )}
    </div>
  );
};
